export const deepCopy = (object) => {
    return JSON.parse(JSON.stringify(object))
}

// returns subset of records from array 'arr' whose type field matches 'type'
export const getRecsOfType = (arr, type) => {
    return arr.filter(rec => rec.type === type)
}

// returns if any of the arrays passed to this have lengths > 0
// perhaps this should be written as a non-1-liner for clarity
export const anyHaveValues = (...arrs) => {
    return arrs.map((arr) => arr.length > 0).filter(val => val === true).length > 0
}

// takes a list of objects and fieldName (key) and returns an object who's attributes are
// the distinct values for that field mapped to a list objects which share that
// value
export const groupByKey = (list, key) => list.reduce(
    (hash, obj) => ({
        ...hash,
        [obj[key]]: (hash[obj[key]] || []).concat(obj)
    }), {}
)
